import styled from '@emotion/styled';

const Container = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 16px;
  padding: 0 20px;
`;

const StyledContent = styled.button<{ clicked: boolean }>`
  color: ${({ clicked }) => (clicked ? 'var(--dk-accent, #06C)' : 'var(--dk-text-strong, #5F636B)')};
  padding: 8px 12px;
  border-radius: 6px;
  background-color: ${({ clicked }) =>
    clicked ? 'rgba(0, 102, 204, 0.10)' : ''};
  transition: all 0.1s ease-in-out;
  white-space: nowrap;
  font-size: 14px;
  line-height: 20px;
`;

const StyledDarkContent = styled.button<{ clicked: boolean }>`
  color: ${({ clicked }) => (clicked ? 'white' : 'var(--dk-text-strong, #5F636B)')};
  padding: 8px 12px;
  border-radius: 6px;
  background-color: ${({ clicked }) => (clicked ? 'black' : 'var(--dk-bg, white)')};
  border: solid 1px ${({ clicked }) => (clicked ? 'black' : '#E7E9EC')};
  transition: all 0.1s ease-in-out;
  white-space: nowrap;
  font-size: 14px;
  line-height: 20px;
`;

export { Container, StyledContent, StyledDarkContent };
